"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { IntegrationAppIntegrationContext } from './use-integration-app-integration.mjs';

const IntegrationAppIntegrationProvider = ({ integrationId, children }) => {
  const value = useMemo(() => ({ integrationId }), [integrationId]);
  return /* @__PURE__ */ jsx(IntegrationAppIntegrationContext.Provider, { value, children });
};

export { IntegrationAppIntegrationProvider };
